import {FieldsI18n} from '@/locales/base.message.locales';

export const fields: FieldsI18n = {
  auth: {
    email: 'Email',
    password: 'Password',
    password_confirmation: 'Password Confirmation',
    current_password: 'Current Password',
  },
  user: {
    first_name: 'First Name',
    last_name: 'Last Name',
    about: 'About',
    birth: 'Birthdate',
    city: 'City of Residence',
    country_of_residence: 'Country of residence',
    created_or_belongs_to_company: 'You created or belong to a company ?',
    gender: 'Gender',
    nationality: 'Nationality',
    student_or_graduate: 'Are you a student or just graduated ?',
    whats_your_profile: 'Whats your profile ?',
  },
  contact: {
    email: 'Email address*',
    message: 'Your message*',
    name: 'Your name*',
    subject: 'Subject*',
  },
  validations: {
    invalid_email: 'Invalid email',
    password: 'Password',
    max_length: 'Max {0} characters',
    min_length: 'Min {0} characters',
    equals: '{0} Must be the same',
    required: 'Field is required',
  },
  topic: {
    description: 'Description',
    title: 'Title',
  },
};
